function handleMouseLeave(index, hoverStates, setHoverStates) {
  const updatedHoverStates = [...hoverStates];
  updatedHoverStates[index] = false;
  setHoverStates(updatedHoverStates);
}

export default handleMouseLeave;
